/* eslint-disable unicorn/no-thenable, unicorn/no-useless-undefined */

import { REQUIRED_FIELD } from '@src/utils';
import * as yup from 'yup';

export const schema = yup.object({
  selectionId: yup.number().required(REQUIRED_FIELD),
  notificationPriority: yup.string().required(REQUIRED_FIELD),
  deliveryChannelTypes: yup.array().of(yup.string()).min(1),
  subject: yup.string().required(REQUIRED_FIELD),
  description: yup.string(),
});
